// extracted by mini-css-extract-plugin
export default {"button":"ProposalListPage_button__aoUCE"};